<div *ngIf="tags?.length" class="home-discover-filter-tags">
  <promo-tag *ngFor="let tag of tags" [options]="tag"></promo-tag>
</div>
<image-tile [imgUrl]="imageUrl" [altText]="altText" class="hover-opacity hoverable-animated"> </image-tile>
